/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var getPath = require('./getPath')

module.exports =
  getPath.origFn('propPath')
